import { IconCursorClick } from "central-icons/IconCursorClick";
import { cn } from "@/lib/utils";

export default function DemoHint({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "flex select-none items-center gap-1.5 text-gray-1000",
        className
      )}
    >
      <span className="hidden size-5 shrink-0 items-center justify-center rounded-full bg-gray-300 sm:flex">
        <IconCursorClick className="size-3.5" />
      </span>
      <span className="text-center text-sm">{children}</span>
    </span>
  );
}
